export default "__VITE_ASSET__CBsVtJmr__"